module.exports = __webpack_public_path__ + "img/Hepsiburada.5ead0426.png";